import { useIsMutating, useMutation } from '@tanstack/react-query'

import { bulkImportResourceLevelRestrictions } from '@/features/site/endpoints/restrictions'
import type { BulkImportRestrictionsRequest } from '@/features/site/types/restriction'

const BULK_IMPORT_RESTRICTIONS_API_ID = 'BULK_IMPORT_RESTRICTIONS'

export function useBulkImportRestrictionsMutation(siteUuid: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: BulkImportRestrictionsRequest) => bulkImportResourceLevelRestrictions(siteUuid, data),
    mutationKey: [BULK_IMPORT_RESTRICTIONS_API_ID, siteUuid],
  })

  return {
    bulkImportRestrictions: mutateAsync,
    ...mutationResult,
  }
}

export const useIsBulkImportingRestrictions = (): boolean =>
  useIsMutating({ mutationKey: [BULK_IMPORT_RESTRICTIONS_API_ID] }) > 0
